import React from 'react'
import Footer from './Footer'
import Intro from './Intro'
import LangCard from './LangCard'

export default function Home() {
    return (
        <>
            <Intro />
            <div className="bgImgDiv mt-16">
                <h1 className='text-5xl font-bold  text-center p-4 border-b-4 border-b-sky-900 w-fit mx-auto'>Cheatsheets</h1>
                <div className='boxes flex items-center justify-center flex-wrap py-10'>
                    <LangCard link="/html" lang="HTML" typeLogo="fa-brands" logo="html5" />
                    <LangCard link="/js" lang="JS" typeLogo="fa-brands" logo="js-square" />
                    <LangCard link="/css" lang="CSS" typeLogo="fa-brands" logo="css3" />
                    <LangCard link="/react" lang="REACT" typeLogo="fa-brands" logo="react" />
                    <LangCard link="/components" lang="COMPONENTS" typeLogo="fa-solid" logo="layer-group" />
                </div>
            </div>
            {/* <Footer /> */}
        </>
    )
}
